import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { TAcceptPsaTermsApiResponse } from '../types/SaveWorkerType.api';

export const acceptPsaTerms = async (): Promise<TAcceptPsaTermsApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.post<TAcceptPsaTermsApiResponse>(
    '/user/tos/psa',
    {},
    { headers },
  );
  return data;
};
